import store from 'store/index';

export const types = {
    RESET: 'RESET',
    UPDATE_MENU: 'UPDATE_MENU',
    COLLAPSE_MENU: 'COLLAPSE_MENU',
    UPDATE_MOBILE_MENU: 'UPDATE_MOBILE_MENU',
    UPDATE_SUBMENU: 'UPDATE_SUBMENU',
    UPDATE_PASSPORT_MENU: 'UPDATE_PASSPORT_MENU'
};

// Initial State
const state = {
    open: false,
    collapsed: false,
    mobileOpen: false,
    subMenu: null,
    passportMenu: false
};

const fetchSubMenu = state => ({
    current: store.getters[`${state.subMenu}/step/currentStep`],
    stepNo: store.getters[`${state.subMenu}/step/currentStepIndex`],
    allSteps: store.getters[`${state.subMenu}/step/allSteps`],
});

// Getters
const getters = {
    isMenuOpen: state => state.open,
    isMenuCollapsed: state => state.collapsed,
    isMobileMenuOpen: state => state.mobileOpen,
    getSubMenu: state => fetchSubMenu(state),
    subMenuStatus: state => state.subMenu,
    isPassportOpen: state => state.passportMenu
};

// Actions
const actions = {
    reset({commit}) { commit(types.RESET); },
    updateMenu({ commit }, menu) { commit(types.UPDATE_MENU, menu); },
    collapseMenu: ({ commit }) => {
        commit(types.COLLAPSE_MENU);
        store.dispatch('headerWidth/updateHeaderWidth', store.getters["headerWidth/theCurrentHeaderWidth"]);
    },
    updateMobileMenu: ({ commit }) => commit(types.UPDATE_MOBILE_MENU),
    updateSubMenu({ commit }, menu) { commit(types.UPDATE_SUBMENU, menu); },
    updatePassportMenu({ commit }, menu) { commit(types.UPDATE_PASSPORT_MENU, menu); }
};


// Mutations
const mutations = {
    [types.RESET](state) {
        state.open = false;
        state.collapsed = false;
        state.mobileOpen = false;
        state.subMenu = null;
        state.passportMenu = false;
    },
    [types.UPDATE_MENU](state, menu) {
        state.open = menu || !state.open;
    },
    [types.COLLAPSE_MENU](state) {
        state.collapsed = !state.collapsed;
    },
    [types.UPDATE_MOBILE_MENU](state) {
        state.mobileOpen = !state.mobileOpen;
    },
    [types.UPDATE_SUBMENU](state, menu) {
        state.subMenu = menu;

        if (!state.subMenu) {
            state.open = false;
        }
    },
    [types.UPDATE_PASSPORT_MENU](state) {
        state.passportMenu = !state.passportMenu;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js